<template>
  <div id="wrapper" class="font-fira">
    <TextHeader :headerTitle="$t('setlists.title')" />
    <div id="content" class="w-container">
      <SectionHeader 
        :text="$t('setlists.title')" 
        :backText="$t('setlists.prBackText')" />
      <div class="row mb-5 setlists-row w-100">
        <div class="col-12 col-md-6 col-lg-4 mb-2" v-for="(item, index) in setlists" v-bind:key="index">
          <div class="setlist-item rounded">
            <img :src="item.image" class="w-100" />
            <h3 class="title px-3">{{ item.title }}</h3>
            <h6 class="setlist-date mb-0"><span>{{ item.date }}</span></h6>
            <a 
              :href="item.link" 
              target="_blank"
              class="see-setlist-button"><b-icon-eye></b-icon-eye> {{ $t("setlists.seeSetlist") }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
  import TextHeader from "./TextHeader";
  import SectionHeader from "./SectionHeader";
  
  export default {
    name: "Setlists",
    components: { SectionHeader, TextHeader },
    data() {
      return {
        setlists: [
          {
            title: "Concert Extraordinar Sebeș",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2025/2025_05_25_Concert_Extraordinar_Sebes.jpg",
            date: "25 Mai 2025",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2025/2025_05_25_Concert_Extraordinar_Sebes.pdf",
          },
          {
            title: "Concert Extraordinar Inaugurare Cazino Constanța",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2025/2025_05_21_Concert_Inaugurare_Cazino_Constanta.jpg",
            date: "Mai 2025",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2025/2025_05_21_Concert_Inaugurare_Cazino_Constanta.pdf",
          },
          {
            title: "Recital Extraordinar Inaugurare Cazino Constanța",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2025/2025_05_21_Recital_Inaugurare_Cazino_Constanta.jpg",
            date: "Mai 2025",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2025/2025_05_21_Recital_Inaugurare_Cazino_Constanta.pdf",
          },
          {
            title: "Madrigal: Drumul Mătăsii",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2025/2025_05_Turneu_Kazahstan_RO.jpg",
            date: "Mai 2025",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2025/2025_05_Turneu_Kazahstan_RO.pdf",
          },
          {
            title: "Madrigal: The Silk Road",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2025/2025_05_Turneu_Kazahstan_EN.jpg",
            date: "Mai 2025",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2025/2025_05_Turneu_Kazahstan_EN.pdf",
          },
          {
            title: "МАДРИГАЛ: ЖІБЕК ЖОЛЫ",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2025/2025_05_Turneu_Kazahstan_KZ.jpg",
            date: "Mai 2025",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2025/2025_05_Turneu_Kazahstan_KZ.pdf",
          },
          {
            title: "Săptămâna Patimilor",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2025/2025_04_Saptamana_Patimilor.jpg",
            date: "Aprilie 2025",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2025/2025_04_Saptamana_Patimilor.pdf",
          },
          {
            title: "Gala Marin Constantin 100",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2025/2025_02_17_Gala_Marin_Constantin_100.jpg",
            date: "27 Februarie 2025",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2025/2025_02_17_Gala_Marin_Constantin_100.pdf",
          },
          {
            title: "Despre Cultură",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2025/2025_01_14_Despre_Cultura.jpg",
            date: "14 Ianuarie 2025",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2025/2025_01_14_Despre_Cultura.pdf",
          },
          {
            title: "Concert Extraordinar de Crăciun - Constanța",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2024/2024_12_22_Constanta.jpg",
            date: "22 Decembrie 2024",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2024/2024_12_22_Constanta.pdf",
          },
          {
            title: "Concert Extraordinar de Crăciun - Brăila",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2024/2024_12_21_Braila.jpg",
            date: "21 Decembrie 2024",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2024/2024_12_21_Braila.pdf",
          },
          {
            title: "Concert Extraordinar de Crăciun - Slobozia",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2024/2024_12_20_Slobozia.jpg",
            date: "20 Decembrie 2024",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2024/2024_12_20_Slobozia.pdf",
          },
          {
            title: "Madrigal: Christmas Mood",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2024/2024_12_Christmas_Mood.jpg",
            date: "Decembrie 2024",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2024/2024_12_Christmas_Mood.pdf",
          },
          {
            title: "Madrigal: Crăciunul Florilor",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2024/2024_12_Craciunul_Florilor.jpg",
            date: "Decembrie 2024",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2024/2024_12_Craciunul_Florilor.pdf",
          },
          {
            title: "Anvers",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2024/2024_11_25_Anvers.jpg",
            date: "25 Noiembrie 2024",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2024/2024_11_25_Anvers.pdf",
          },
          {
            title: "Bruxelles",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2024/2024_11_24_Bruxelles.jpg",
            date: "24 Noiembrie 2024",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2024/2024_11_24_Bruxelles.pdf",
          },
          {
            title: "Bruges",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2024/2024_11_23_Bruges.jpg",
            date: "23 Noiembrie 2024",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2024/2024_11_23_Bruges.pdf",
          },
          {
            title: "Bruxelles",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2024/2024_11_21_Bruxelles.jpg",
            date: "21 Noiembrie 2024",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2024/2024_11_21_Bruxelles.pdf",
          },
          {
            title: "Luxemburg",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2024/2024_11_20_Luxemburg.jpg",
            date: "20 Noiembrie 2024",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2024/2024_11_20_Luxemburg.pdf",
          },
          {
            title: "Visul European",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2024/2024_11_Visul_European.jpg",
            date: "Noiembrie 2024",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2024/2024_11_Visul_European.pdf",
          },
          {
            title: "Pantheon Roma",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2024/2024_10_02_Pantheon_Roma.jpg",
            date: "2 Octombrie 2024",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2024/2024_10_02_Pantheon_Roma.pdf",
          },
          {
            title: "Terme di Diocleziano Roma",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2024/2024_10_01_Terme_di_Diocleziano_Roma.jpg",
            date: "1 Octombrie 2024",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2024/2024_10_01_Terme_di_Diocleziano_Roma.pdf",
          },
          {
            title: "Madrigal: Ritualuri",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2024/2024_08_Madrigal_Ritualuri.jpg",
            date: "August 2024",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2024/2024_08_Madrigal_Ritualuri.pdf",
          },
          {
            title: "Madrigal: Ritualuri",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2024/2024_06_Madrigal_Ritualuri.jpg",
            date: "Iunie 2024",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2024/2024_06_Madrigal_Ritualuri.pdf",
          },
          {
            title: "Madrigal cântă copiilor",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2024/2024_06_02_Madrigal_canta_copiilor.jpg",
            date: "2 Iunie 2024",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2024/2024_06_02_Madrigal_canta_copiilor.pdf",
          },
          {
            title: "Madrigal pentru suflet",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2024/2024_05_25_Madrigal_pentru_suflet.jpg",
            date: "25 Mai 2024",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2024/2024_05_25_Madrigal_pentru_suflet.pdf",
          },
          {
            title: "Madrigal for Babies",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2024/2024_04_02_Madrigal_for_Babies.jpg",
            date: "Aprilie 2024",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2024/2024_04_02_Madrigal_for_Babies.pdf",
          },
          {
            title: "Săptămâna Patimilor",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2024/2024_04_07_Saptamana_Patimilor.jpg",
            date: "Aprilie 2024",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2024/2024_04_07_Saptamana_Patimilor.pdf",
          },
          {
            title: "Concert Extraordinar de Paște",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2024/2024_04_Concert_Extraordinar_de_Paste.jpg",
            date: "Aprilie 2024",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2024/2024_04_Concert_Extraordinar_de_Paste.pdf",
          },
          {
            title: "Turneu în Perú",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2024/2024_03_Turneu_in_Peru.jpg",
            date: "Martie 2024",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2024/2024_03_Turneu_in_Peru.pdf",
          },
          {
            title: "Shakespeare - Sunet și Cuvânt",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2024/2024_03_06_Shakespeare_Sunet_si_Cuvant.jpg",
            date: "6 Martie 2024",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2024/2024_03_06_Shakespeare_Sunet_si_Cuvant.pdf",
          },
          {
            title: "Madrigal 61",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2024/2024_02_27_Madrigal_61.jpg",
            date: "27 Februarie 2024",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2024/2024_02_27_Madrigal_61.pdf",
          },
          {
            title: "Despre Cultură",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2024/2024_01_15_Despre_Cultura.jpg",
            date: "15 Ianuarie 2024",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2024/2024_01_15_Despre_Cultura.pdf",
          },
          {
            title: "Madrigal de Crăciun - Mănăstirea Pantocrator",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2023/2023_12_Madrigal_de_Craciun.jpg",
            date: "23 Decembrie 2023",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2023/2023_12_23_Madrigal_de_Craciun.pdf",
          },
          {
            title: "Pe drumul Crăciunului",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2023/2023_12_Pe_drumul_Craciunului.jpg",
            date: "Decembrie 2023",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2023/2023_12_19_Pe_drumul_Craciunului.pdf",
          },
          {
            title: "Madrigal de Crăciun - Banca Națională a României",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2023/2023_12_Madrigal_de_Craciun.jpg",
            date: "18 Decembrie 2023",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2023/2023_12_18_Madrigal_de_Craciun.pdf",
          },
          {
            title: "Madrigal de Crăciun - Catedrala Metropolitană",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2023/2023_12_Madrigal_de_Craciun.jpg",
            date: "16 Decembrie 2023",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2023/2023_12_16_Madrigal_de_Craciun.pdf",
          },
          {
            title: "Madrigal de Crăciun - Biserica Ursulinelor",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2023/2023_12_Madrigal_de_Craciun.jpg",
            date: "15 Decembrie 2023",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2023/2023_12_15_Madrigal_de_Craciun.pdf",
          },
          {
            title: "Concert Extraordinar Muzică Sacră",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2023/2023_10_12_Concert_Extraordinar_Muzica_Sacra.jpg",
            date: "Octombrie 2023",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2023/2023_10_12_Concert_Extraordinar_Muzica_Sacra.pdf",
          },
          {
            title: "Ave Maria",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2023/2023_08_Ave_Maria.jpg",
            date: "August 2023",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2023/2023_08_Ave_Maria.pdf",
          },
          {
            title: "Extraordinary Concert Madrigal 60",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2023/2023_07_06_Madrigal+60.jpg",
            date: "6 Iulie 2023",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2023/2023_07_06_Madrigal+60.pdf",
          },
          {
            title: "Madrigal for Babies",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2023/2023_06_03_Madrigal_For_Babies.jpg",
            date: "3 Iunie 2023",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2023/2023_06_03_Madrigal_For_Babies.pdf",
          },
          {
            title: "Concert in Memoriam Jacques Menachem Elias",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2023/2023_05_16_Concert_in_Memoriam_Jacques_Menachem_Elias.jpg",
            date: "16 Mai 2023",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2023/2023_05_16_Concert_in_Memoriam_Jacques_Menachem_Elias.pdf",
          },
          {
            title: "Concert Extraordinar Banca Națională a României",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2023/2023_05_15_BNR.jpg",
            date: "15 Mai 2023",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2023/2023_05_15_BNR.pdf",
          },
          {
            title: "Săptămâna Patimilor",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2023/2023_04_Album_Foto_Madrigal_Saptamana_Patimilor.jpg",
            date: "Aprilie 2023",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2023/2023_04_Album_Foto_Madrigal_Saptamana_Patimilor.pdf",
          },
          {
            title: "Săptămâna Patimilor",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2023/2023_03_Saptamana_Patimilor.jpg",
            date: "Martie 2023",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2023/2023_03_Saptamana_Patimilor.pdf",
          },
          {
            title: "Madrigal 60",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2023/2023_02_28_Madrigal+60.jpg",
            date: "28 Februarie 2023",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2023/2023_02_28_Madrigal+60.pdf",
          },
          {
            title: "Despre Cultură",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2023/2023_01_21_Despre_Cultura.jpg",
            date: "21 Ianuarie 2023",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2023/2023_01_21_Despre_Cultura.pdf",
          },
          {
            title: "Pe drumul Crăciunului",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2022/2022_12_16_Pe_drumul_Craciunului.jpg",
            date: "Decembrie 2022",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2022/2022_12_16_Pe_drumul_Craciunului.pdf",
          },
          {
            title: "Casa Colindelor",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2022/2022_12_04_Casa_Colindelor.jpg",
            date: "Decembrie 2022",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2022/2022_12_04_Casa_Colindelor.pdf",
          },
          {
            title: "The Music of European Renaissance",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2022/2022_11_02_The_Music_of_European_Renaissance_en.jpg",
            date: "2 Noiembrie 2022",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2022/2022_11_02_The_Music_of_European_Renaissance_en.pdf",
          },
          {
            title: "Salve Regina",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2022/2022_10_08_Salve_Regina.jpg",
            date: "10 Octombrie 2022",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2022/2022_10_08_Salve_Regina.pdf",
          },
          {
            title: "Ave Maria",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2022/2022_08_15_Ave+Maria.jpg",
            date: "15 August 2022",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2022/2022_08_15_Ave+Maria.pdf",
          },
          {
            title: "Gala Madrigal 59",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2022/2022_06_30_Gala_Madrigal_59.jpg",
            date: "30 Iunie 2022",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2022/2022_06_30_Gala_Madrigal_59.pdf",
          },
          {
            title: "The Music of European Renaissance",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2022/2022_06_09_+The_Music_of_European_Renaissance_en.jpg",
            date: "9 Iunie 2022",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2022/2022_06_09_+The_Music_of_European_Renaissance_en.pdf",
          },
          {
            title: "The Music of European Renaissance Bilingv",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2022/2022_06_09_+The_Music_of_European_Renaissance_bilingv.jpg",
            date: "9 Iunie 2022",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2022/2022_06_09_+The_Music_of_European_Renaissance_bilingv.pdf",
          },
          {
            title: "Shakespeare - Sunet și Cuvant",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2022/2022_05_26_Shakespeare_Sunet_si_Cuvant.jpg",
            date: "26 Mai 2022",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2022/2022_05_26_Shakespeare_Sunet_si_Cuvant.pdf",
          },
          {
            title: "Săptămâna Patimilor",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2022/2022_04_Saptamana_Patimilor.jpg",
            date: "Aprilie 2022",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2022/2022_04_Saptamana_Patimilor.pdf",
          },
          {
            title: "Pe Drumul Crăciunului",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2021/2021_12_Pe_drumul_Craciunului.jpg",
            date: "Decembrie 2021",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2021/2021_12_Pe_drumul_Craciunului.pdf",
          },
          {
            title: "Classical Christmas Market",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2021/2021_12_Classical_Christmas_Market.jpg",
            date: "Decembrie 2021",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2021/2021_12_Classical_Christmas_Market.pdf",
          },
          {
            title: "Jerusalem of Gold RO",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2021/2021_10_03_Jerusalem_of_Gold_ro.jpg",
            date: "3 Octombrie 2021",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2021/2021_10_03_Jerusalem_of_Gold_ro.pdf",
          },
          {
            title: "Jerusalem of Gold EN",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2021/2021_10_03_Jerusalem_of_Gold_en.jpg",
            date: "3 Octombrie 2021",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2021/2021_10_03_Jerusalem_of_Gold_en.pdf",
          },
          {
            title: "Nihil Sine Deo",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2021/2021_09_05_Nihil_Sine_Deo_Sf_Iosif.jpeg",
            date: "5 Septembrie 2021",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2021/2021_09_05_Nihil_Sine_Deo_Sf_Iosif.pdf",
          },
          {
            title: "Ave Maria",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2021/2021_08_29_Ave_Maria.jpg",
            date: "29 August 2021",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2021/2021_08_29_Ave_Maria.pdf",
          },
          {
            title: "Ave Maria",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2021/2021_08_15_Ave_Maria.jpg",
            date: "15 August 2021",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2021/2021_08_15_Ave_Maria.pdf",
          },
          {
            title: "Muzica Renașterii",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2020/2020_Muzica_Renasterii.jpg",
            date: "2020",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2020/2020_Muzica_Renasterii.pdf",
          },
          {
            title: "Hora Staccato",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2020/2020_Hora_Staccato.jpg",
            date: "2020",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2020/2020_Hora_Staccato.pdf",
          },
          {
            title: "Cântă Copiilor",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2020/2020_Canta_copiilor.jpg",
            date: "2020",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2020/2020_Canta_copiilor.pdf",
          },
          {
            title: "Bijuterii Corale RO",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2020/2020_Bijuterii_Corale_ro.jpg",
            date: "2020",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2020/2020_Bijuterii_Corale_ro.pdf",
          },
          {
            title: "Bijuterii Corale EN",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2020/2020_Bijuterii_Corale_en.jpg",
            date: "2020",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2020/2020_Bijuterii_Corale_en.pdf",
          },
          {
            title: "Ave Maria RO",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2020/2020_Ave_Maria_ro.jpg",
            date: "2020",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2020/2020_Ave_Maria_ro.pdf",
          },
          {
            title: "Ave Maria EN",
            image: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/previews/2020/2020_Ave_Maria_en.jpg",
            date: "2020",
            link: "https://madrigal-public.s3.eu-central-1.amazonaws.com/setlists/pdfs/2020/2020_Ave_Maria_en.pdf",
          },
        ]
      }
    },
  };
</script>
  
<style scoped lang="scss">
  .setlists-row {
    padding: 0 5px;;
  }
  .setlist-item {
    background: white;
    color: #3d5262;
    position: relative;

    h3 {
      height: 11rem;
      line-height: 2rem;
    }
    
    .setlist-date {
      padding: 15px;
      position: absolute;
      bottom: 0;
      left: 0;
    }
    .see-setlist-button {
      padding: 15px;
      background: #e7e7e7;
      color: #7a8994;
      text-decoration: none;
      position: absolute;
      bottom: 0;
      right: 0;
    }

    .see-setlist-button:hover {
      text-decoration: none;
      background-color: black;
      color: white;
    }
  }
</style>
  